import { render, staticRenderFns } from "./creation-list.vue?vue&type=template&id=5643b32e&scoped=true"
import script from "./creation-list.vue?vue&type=script&lang=js"
export * from "./creation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643b32e",
  null
  
)

export default component.exports